import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import Login from "../components/Login";
import Faltas from "../components/Faltas";
import CapturaExcepciones from "../components/Bonos";
import CambioSalario from "../components/CambioSalario";
import Bajas from "../components/Bajas";
import ListadoFaltas from "../components/FaltasListado";
import ListadoBonos from "../components/BonosListado";
import ListadoSolicitudesCambioSalario from "../components/CambioSalarioListado";
import ListadoBajas from "../components/BajasListado";
import useAuth from "../hooks/useAuth";
import RequireAuth from "../components/RequireAuth";
import PersistLogin from "../components/PersistLogin";
import Home from "../components/Home";
import EditorHome from "../components/EditorHome";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AdminShell from "../components/AdminShell";
import Dashboard from "../components/Dashboard";
import Settings from "../components/Settings";
import Users from "../components/Users";
import ListadoEmpleados from "../components/EmpleadosListado";
import ListadoEmpleadosEditor from "../components/EditorEmpleados";
import EditorVacaciones from "../components/EditorVacaciones";
import FormularioEmpleado from "../components/EditorEmpleadosCreate";
import IncidenciasTransferencia from "../components/EditorIncidenciasTransferencia";
import BonosTransferencia from "../components/EditorBonosTransferencia";
import BajasTransferencia from "../components/EditorBajas";
import PerfilUsuario from '../components/PerfilUsuario';
import ConfiguracionSistema from '../components/ConfiguracionSistema';

const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};
export function MyRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();
  console.log(auth);
  localStorage.setItem("usuario", JSON.stringify(auth.user));

  if (["/login", "/register", "/forgot-password"].includes(location.pathname)) {
    document.body.classList.add("login-page");
  } else {
    document.body.classList.remove("login-page");
  }

  // const MyRoutes = () => {
  return (
    <>
      <Routes>
        {/* public routes */}
        <Route path="login" element={<Login />} />

        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
            <Route path="/" element={<Layout Auth={auth} />}>
              <Route index element={<Home />} />
              <Route path="perfil" element={<PerfilUsuario  Auth={auth}/>} />
              <Route path="configuracion" element={<ConfiguracionSistema  Auth={auth}/>} />
              <Route
                path="empleados/listado" element={<ListadoEmpleados Auth={auth} />}
              />              
              <Route path="faltas">
                <Route index element={<Faltas />} />
                <Route path=":idFalta" element={<Faltas />} />
                <Route path="listado" element={<ListadoFaltas />} />
              </Route>
              <Route path="bonos">
                <Route index element={<CapturaExcepciones />} />
                <Route path=":idCaptura" element={<CapturaExcepciones />} />
                <Route path="listado" element={<ListadoBonos />} />
              </Route>
              <Route path="cambio-salario">
                <Route index element={<CambioSalario />} />
                <Route path=":idRegistro" element={<CambioSalario />} />
                <Route
                  path="listado"
                  element={<ListadoSolicitudesCambioSalario />}
                />
              </Route>
              <Route path="baja-empleados">
                <Route index element={<Bajas />} />
                <Route path=":idRegistro" element={<Bajas />} />
                <Route path="listado" element={<ListadoBajas />} />
              </Route>
            </Route>
          </Route>
        </Route>
        {/* <Route path="unauthorized" element={<Unauthorized />} /> */}
        {/* catch all */}
        {/* <Route path="*" element={<Missing />} /> */}
        {/* </Route> */}
      </Routes>
      <Routes>
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.Editor]} />}>
            <Route path="/editor" element={<Layout Auth={auth} />}>
              <Route index element={<EditorHome />} />
              <Route path="empleados/listado" element={<ListadoEmpleadosEditor />} />
              <Route path="vacaciones/listado" element={<EditorVacaciones />} />
              <Route path="empleados/transferir" element={<FormularioEmpleado />} />
              <Route path="incidencias/transferir" element={<IncidenciasTransferencia Auth={auth}  />} />
              <Route path="bonos/transferir" element={<BonosTransferencia Auth={auth}  />} />
              <Route path="bajas/listado" element={<BajasTransferencia Auth={auth}  />} />
              <Route path="ajustes" element={<Settings />} />
            </Route>
          </Route>
        </Route>
      </Routes>
      <Routes>
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<Dashboard />} />
              <Route path="usuarios" element={<Users />} />
              <Route path="ajustes" element={<Settings />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}
//export default MyRoutes
